import Embedded from './Embedded';

export default Embedded;
